export class EnvironnementLabel {
    static jsonMap = {
        id: { key: 'id' },
        libelle: { key: 'libelle', optional: true, default: '' }
    };

    id: number;
    libelle: string;
}
